import { render, staticRenderFns } from "./ThirdPartyDocument.vue?vue&type=template&id=791083d4&scoped=true&"
import script from "./ThirdPartyDocument.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791083d4",
  null
  
)

export default component.exports